"use strict";
import React from "react";
import PropTypes from "prop-types";

class FormError extends React.Component {

    getErrorMessage() {
        // remove ternar before commit
        const { errors } = this.context.formsyFormErrorsProvider ? this.context.formsyFormErrorsProvider : { errors: {} };

        return errors[this.props.name];
    }

    render() {
        return this.getErrorMessage() ? (
            <div className="form-error form-group has-error has-feedback">
                <span className="alert alert-danger help-block validation-message">{this.getErrorMessage()}</span>
            </div>
        ) : null;
    }
}

FormError.propTypes = {
    name: PropTypes.string.isRequired
};

FormError.contextTypes = {
    formsyFormErrorsProvider: PropTypes.shape({
        errors: PropTypes.object.isRequired
    }).isRequired
};

module.exports = FormError;